import { MouseEventHandler, ReactElement, useRef, useState } from "react";

import { SVG_MUI } from "@ryde/assets";
import { useDynamicFormsUtils, useTableFiltersActions } from "@ryde/redux";

import {
  FreeTextFieldInputStyled,
  FreeTextFieldLabel,
  FreeTextFieldWrapper,
} from "./free-text.style";

interface IFilterFreeText {
  customFieldId: number;
  value: string;
}

export const FilterFreeText = ({
  customFieldId,
  value,
}: IFilterFreeText): ReactElement => {
  const freeTextFieldRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState(false);

  const { getGridControlLabelById } = useDynamicFormsUtils();
  const { setValuesToFilter } = useTableFiltersActions();
  const { handleRemoveFilter } = useTableFiltersActions();
  const label = customFieldId ? getGridControlLabelById(customFieldId) : "";

  const removeFilter: MouseEventHandler = e => {
    e.stopPropagation();
    handleRemoveFilter(customFieldId);
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setValuesToFilter(customFieldId, [event.target.value]);
  };

  const onBlur = (): void => {
    setIsFocused(false);
  };

  return (
    <FreeTextFieldWrapper
      onClick={() => {
        freeTextFieldRef.current?.focus();
      }}
    >
      <FreeTextFieldLabel htmlFor={label}>{label}</FreeTextFieldLabel>
      <FreeTextFieldInputStyled
        inputRef={freeTextFieldRef}
        name={label}
        focused={isFocused}
        placeholder="--"
        value={value ?? ""}
        onBlur={onBlur}
        onFocus={() => setIsFocused(true)}
        onChange={onChange}
      />
      <SVG_MUI.CircleXMark
        className="circle-x-mark"
        onClick={e => removeFilter(e)}
      />
    </FreeTextFieldWrapper>
  );
};
